<template>
  <div class="courses-wrap">
    <div class="courses-content">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :lg="17">
          <div class="courses-left">
            <div class="video-courses">
              <h2>{{freeCourse.title}}</h2>
              <div class="vide-courese-box"><video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player></div>
            </div>

            <div class="courses-info">
              <div class="hd">
                <el-row :gutter="10">
                  <el-col class="hd-item" :xs="8" :sm="8" :lg="3"><a href="javascript:;" @click="current = 0" :class="{ hover: current == 0 }">课程介绍</a></el-col>
                  <el-col class="hd-item" :xs="8" :sm="8" :lg="3"><a href="javascript:;" @click="current = 1" :class="{ hover: current == 1 }">图文介绍</a></el-col>
                </el-row>
              </div>
              <div class="bd">
                <div class="item" v-show="current == 0" v-html="freeCourse.introduction">
                </div>
                <div class="item" v-show="current == 1" v-html="freeCourse.content"></div>
              </div>
            </div>
            <div class="courses-class">
              <div class="common-hd">精品课程推荐</div>
              <el-row :gutter="20">
                <el-col :xs="8" :lg="8" v-for="item in courseList" :key="item.id">
                  <a :href="'/paidCourses/'+item.id">
                    <img :src="item.imgUrl">
                  </a>
                </el-col>
                <!--<el-col :xs="8" class="hf-col-lg-5"><a href=""><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/a2.png"></a></el-col>
                <el-col :xs="8" class="hf-col-lg-5"><a href=""><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/a3.png"></a></el-col>
                <el-col :xs="8" class="hf-col-lg-5"><a href=""><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/a4.png"></a></el-col>
                <el-col :xs="8" class="hf-col-lg-5"><a href=""><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/a5.png"></a></el-col>-->
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="7">
          <div class="courses-right">
            <!--相关课程推荐-->
            <div class="rec-courses">
              <h2>相关课程推荐</h2>
              <ul>
                <li v-for="index of 10" >
                  <a :href="'/freeCourses/'+index" :class="index==courseId?'hover':''">
                    <i></i>
                    {{"课程"+index +"："+freeCourseList[index].title}}
                  </a>
                </li>
              </ul>
            </div>
            <div class="college">
              <div class="c-hd">现代物业（精装12期）</div>
              <div class="bd">
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/zazhi.png"></div>
                <p>弘范智汇是面向广大清洁从业者的学习平台，为从业者提供理论知识、技能实操、专业认证优质课程内容。</p>
                </div>
              <div class="btn"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740" target="_blank" class="btn-gray">联系客服购买</a></div>
            </div>
            <div class="college">
              <div class="c-hd">弘范学院</div>
              <div class="bd"><p>弘范智汇是面向广大清洁从业者的学习平台，为从业者提供理论知识、技能实操、专业认证优质课程内容。</p></div>
              <div class="btn"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740"  target="_blank">认证培训</a></div>
            </div>
            <!--商业合作-->
            <div class="college">
              <div class="c-hd">商业合作</div>
              <div class="bd"><p>请扫码加入清洁培训交流群</p></div>
              <div class="qcode"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/qcode.png" width="200" height="200" /></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--返回顶部-->
     <el-backtop></el-backtop>
  </div>
</template>

<script>
import Vue from 'vue'
import VideoPlayer from 'vue-video-player';
import 'vue-video-player/src/custom-theme.css';
import 'video.js/dist/video-js.css';
import freeCourseList from '../assets/json/video.json';

Vue.use(VideoPlayer);
export default {
  data() {
    return {
      current: 0,
      path: domain.apiUrl,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: 'video/mp4',
            //url地址
            src: '',
          }
        ],
        //你的封面地址
        poster: 'https://jiemancang.oss-cn-beijing.aliyuncs.com/qingjiegongsi/video/v-fengmian.jpg',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }

      },
      freeCourse : {},
      freeCourseList:freeCourseList,
      courseList:[],
      courseId:this.$route.params.id

    };
  },
  created(){
    this.getfreeCourse();
    this.getCourse();

  },
  methods:{
    getfreeCourse: function () {
      let id = this.courseId;
      this.freeCourse = freeCourseList[id];
      this.playerOptions['sources'][0]['src']  = this.freeCourse.video;
      this.playerOptions.poster  = this.freeCourse.img;
    },
    getCourse:function () {
      this.$http.get(this.path + '/course/list?type=1').then((response) => {
        if (response.status === 200) {
          this.courseList = response.body;

        }
      }, (response) => {
        this.$message.error("error")
      });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/paidcourses.scss';
</style>



// WEBPACK FOOTER //
// src/components/freeCourses.vue